import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { ProjectTechnology, TechnologyCollection, BiogasProjectTechnology } from '@/features/projects/types';
import { BiogasFormNew, BiogasSubmitFields } from './biogas-form-new';

export type BiogasDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: BiogasProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
};

export function BiogasDrawer({ formId, technology, isOpen, onSubmit, onClose }: BiogasDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Biogas Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <BiogasFormNew
        id={formId}
        item={technology?.item as BiogasProjectTechnology}
        onSubmit={(data: BiogasSubmitFields) =>
          onSubmit(
            'projects_biogas_technologies',
            { ...technology?.item, ...data, development_status: data.development_status ?? undefined },
            t('Biogas Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
